import {Element} from 'react-scroll';
import type {DynamicPageServerSideProps} from '@/_application/core/types';
import {PropsWithChildren} from 'react';

// This layout is used for the category page. It must be used as contents layout within the main layout.
export default function CategoryPageLayout({children}: DynamicPageServerSideProps & PropsWithChildren<{}>) {
    return (
        <div className="flex flex-1 bg-secondary">
            <main className="block w-full xl:overflow-hidden">
                <Element name="grid">{children}</Element>
            </main>
        </div>
    );
}
